import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { OnInit } from 'cv-ng-metadata/core';
import { Subscription } from 'rxjs';
import { BattleBoatPlayerStatus, ChallengeBattleShipService } from 'src/app/gamification/command-center/services/challenge-battle-ship.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-battle-boat-details',
  templateUrl: './battle-boat-details.component.html',
  styleUrl: './battle-boat-details.component.scss',
  providers: [ChallengeBattleShipService] // providing service at the component level
})
export class BattleBoatDetailsComponent implements OnInit, OnChanges, OnDestroy {

  private subscriptions = new Subscription();
  @Input() challenge: any = null;


  @Output()
  updatePlayer: EventEmitter<{ GameStatus: number }> = new EventEmitter();

  public localization: Map<string, string> = new Map();

  isDisplayingMygrid = true;
  player: {
    GameStatus: number;
  } = {
      GameStatus: 0,
    };

  constructor(
    private challengeBattleBoatService: ChallengeBattleShipService, 
    private cvLocalizationService: CVLocalizationService
  ) {}

  async ngOnInit() {
    this.localization = await this.cvLocalizationService.GetSection("Challenges_Details") ?? new Map<string, string>();
    this.subscriptions.add(this.challengeBattleBoatService.player$.subscribe(player => {
      this.player = player;
      this.updatePlayer.emit(this.player);
    }));
  }

  get isPlayerWinner() {
    return this.player.GameStatus === BattleBoatPlayerStatus.VICTORY || (this.player.GameStatus === BattleBoatPlayerStatus.PAID && this.challenge?.Rank === "1st");
  }

  get isPlayerDefeated() {
    return this.player.GameStatus === BattleBoatPlayerStatus.DEFEAT || (this.player.GameStatus === BattleBoatPlayerStatus.PAID && this.challenge?.Rank === "2nd");
  }

  get isPlayerDraw() {
    return this.player.GameStatus === BattleBoatPlayerStatus.DRAW || this.player.GameStatus === BattleBoatPlayerStatus.RETURNED;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  displayMyGrid() {
    this.isDisplayingMygrid = true;
  }

  displayRivalGrid() {
    this.isDisplayingMygrid = false;
  }

  goBackFn() {
    console.log('goBackFn');
  }
}
